export default __webpack_public_path__ + "static/media/solution-robocup.d06df03e.png";